import { Injectable } from '@angular/core';
import * as constants from '../constants/app.constant'; // 사용자 정의 상수

@Injectable()
export class PatternService {
    processing: boolean;
    constructor() { // private http: RestHttpClient
    }

    showPattern(ViewObj: any) {
        this.processing = true;
        const setData = ViewObj;
        setData.setPattern = [];

        // 수정을 위해서 기존 폼과 동일하게 변수값 맞추기
        setData.patternDisable = ViewObj.disable === 'true' ? true : false;
        const GAME_TYPE = constants.GAME_TYPE;
        setData.options = GAME_TYPE[setData.game];
        setData.controllIcons = this.setoption({game: setData.game, option: setData.option});

        const cPattern = ViewObj.pattern;
        let curSet = null;
        let curSetIndex = 0;
        for ( const pattern of cPattern) {
            // const pattern = cPattern[i];
            if (curSet === null) { // 맨처음 입력값일 경우
                curSet = pattern;
                setData.setPattern[curSetIndex] = [pattern];
            } else { // 이전 값과 비교하여 처리

                if (curSet === pattern) {
                    setData.setPattern[curSetIndex].push(pattern);
                } else {
                    curSetIndex++;
                    setData.setPattern[curSetIndex] = [pattern];
                }
                curSet = pattern;
            }
        }
        return setData;
    } // this.showPattern = function(ViewObj) {

    setoption(params: any) { // {game, option}
        const icons = [];
        switch (params.game) {
            case 'ladder':
            case 'dari':
            case 'powerLadder':
                switch (params.option) {
                    case 'START':
                        icons.push({pattern: '1', class: 'blue', txt: '좌'});
                        icons.push({pattern: '2', class: 'red', txt: '우'});
                        break;
                    case 'LINE':
                        icons.push({pattern: '3', class: 'blue', txt: '3'});
                        icons.push({pattern: '4', class: 'red', txt: '4'});
                        break;
                    case 'ODDEVEN':
                        icons.push({pattern: '1', class: 'blue', txt: '홀'});
                        icons.push({pattern: '2', class: 'red', txt: '짝'});
                        break;
                    case 'ALLKILL':
                        icons.push({pattern: '14', class: 'blue', txt: '좌4'});
                        icons.push({pattern: '23', class: 'dblue', txt: '우3'});
                        icons.push({pattern: '13', class: 'red', txt: '좌3'});
                        icons.push({pattern: '24', class: 'dred', txt: '우4'});
                        break;
                }
                break;
            case 'powerball':
                switch (params.option) {
                    case 'PODDEVEN':
                    case 'NODDEVEN':
                        icons.push({pattern: '1', class: 'blue', txt: '홀'});
                        icons.push({pattern: '0', class: 'red', txt: '짝'});
                        break;
                    case 'PLOWHIGH':
                    case 'NLOWHIGH':
                        icons.push({pattern: '0', class: 'blue', txt: '언'});
                        icons.push({pattern: '1', class: 'red', txt: '오'});
                        break;
                    case 'NSCALE':
                        icons.push({pattern: '3', class: 'red', txt: '대'});
                        icons.push({pattern: '2', class: 'blue', txt: '중'});
                        icons.push({pattern: '1', class: 'green', txt: '소'});
                        break;
                }
                break;
        }
        return icons;
    } // this.setoption = function(params);
}
